import { Route, Routes } from 'react-router-dom'
import { RequireAuth } from '@astro/auth'
import { MobileBottomNav } from '@astro/layouts'
import Header from './components/layout/Header'
import Footer from '@astro/footer'
import FloatingFabs from '@astro/floating-fabs'
import ShopHome from './pages/ShopHome'
import PoojaEnergization from './pages/PoojaEnergization'
import PoojaDetails from './pages/PoojaDetails'
import PoojaCheckout from './pages/PoojaCheckout'
import PoojaBookingConfirmed from './pages/PoojaBookingConfirmed'
import Products from './pages/Products'
import ProductDetails from './pages/ProductDetails'
import Cart from './pages/Cart'
import Wishlist from './pages/Wishlist'
import OrderConfirmed from './pages/OrderConfirmed'
import OrderDetails from './pages/OrderDetails'
import TrackOrder from './pages/TrackOrder'
import ScrollManager from './components/common/ScrollManager'

export default function App() {
  return (
    <div className="bg-background text-foreground min-h-screen flex flex-col antialiased">
      <ScrollManager />
      <Header />
      {/* Header is fixed and overlays content (transparent over dark heroes on
          home/products, solid white elsewhere). Each page owns its top clearance. */}
      <main className="grow">
        <Routes>
          <Route path="/" element={<ShopHome />} />
          <Route path="/pooja-energization" element={<PoojaEnergization />} />
          <Route path="/pooja-energization/:slug" element={<PoojaDetails />} />
          {/* Public order tracking - must stay above /:category, which would swallow it. */}
          <Route path="/track-order" element={<TrackOrder />} />
          <Route path="/:category" element={<Products />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/:slug" element={<ProductDetails />} />
          <Route element={<RequireAuth fallback={<div className="p-10 text-center">Checking session…</div>} />}>
            <Route path="/pooja-energization/checkout" element={<PoojaCheckout />} />
            <Route path="/pooja-energization/booking-confirmed" element={<PoojaBookingConfirmed />} />
            <Route path="/checkout" element={<Cart />} />
            <Route path="/wishlist" element={<Wishlist />} />
            <Route path="/order-confirmed" element={<OrderConfirmed />} />
            <Route path="/orders/:orderNumber" element={<OrderDetails />} />
          </Route>
          <Route path="*" element={<ShopHome />} />
        </Routes>
      </main>
      <Footer />
      <MobileBottomNav />
      <FloatingFabs />
    </div>
  )
}
